module.exports = __webpack_public_path__ + "img/Shape_Title.510aa8cb.svg";